import { useState } from "react";
import { toast } from "sonner";
import { Mail, KeyRound } from "lucide-react";
import { pub, errMsg } from "@/lib/api";

export default function CodeLogin({ onVerified }) {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const { data } = await pub.post("/family/request-code", { email });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await pub.post("/family/verify", { email, code });
      onVerified(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (!sent)
    return (
      <form onSubmit={send} className="card-warm space-y-5" data-testid="code-request-form">
        <Mail className="w-10 h-10 text-[#8C3415]" />
        <h2 className="text-2xl sm:text-3xl font-bold text-amber-900">Sign in with your email</h2>
        <p className="text-lg">Type the email you used to register. We'll email you a 6-digit code.</p>
        <input required type="email" data-testid="edit-registration-email-input" className="field" placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button disabled={busy} data-testid="request-code-button" className="btn-primary w-full">{busy ? "Sending…" : "Email me a code"}</button>
      </form>
    );

  return (
    <form onSubmit={verify} className="card-warm space-y-5" data-testid="code-verify-form">
      <KeyRound className="w-10 h-10 text-[#2B5338]" />
      <h2 className="text-2xl sm:text-3xl font-bold text-amber-900">Check your email</h2>
      <p className="text-lg">We sent a code to <b>{email}</b>. Type it below.</p>
      <input required data-testid="edit-registration-code-input" inputMode="numeric" autoComplete="one-time-code" maxLength={6}
        className="field text-center !text-3xl tracking-[0.5em] font-bold" placeholder="••••••" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} />
      <button disabled={busy || code.length < 6} data-testid="verify-code-button" className="btn-primary w-full">{busy ? "Checking…" : "Open my registration"}</button>
      <div className="flex flex-wrap gap-3">
        <button type="button" data-testid="resend-code-button" onClick={send} className="btn-outline">Send a new code</button>
        <button type="button" data-testid="change-email-button" onClick={() => { setSent(false); setCode(""); }} className="btn-outline">Use a different email</button>
      </div>
    </form>
  );
}
